<template>
	<Head>
		<title>{{ title }} - Bell Oldow, Inc.</title>
		<meta v-if="desc" name="description" :content="desc">
	</Head>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'

export default {
	components: {
		Head
	},
	props: {
		title: {
			type: String,
			default: 'TODO',
			required: true
		},
		desc: {
			type: String,
			default: 'TODO',
			required: false
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
